import { EventEmitter, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SelectedHotelService {
  selectedHotel = signal<google.maps.places.PlaceResult>(null);
  onHotelChange = new EventEmitter<google.maps.places.PlaceResult>();

  constructor() {}

  setHotel(hotel?: google.maps.places.PlaceResult) {
    this.selectedHotel.set(hotel);
    this.onHotelChange.emit(hotel);
  }
}
